export const typeScale = {
  display: '28px',
  heading: '18px',
  subheading: '14px',
  body: '16px',
  caption: '12px',
  button: '14px',
};

export const lineHeight = {
  display: '32px',
  heading: '24px',
  subheading: '16px',
  body: '20px',
  caption: '16px',
  button: '18px',
};

export const fontWeight = {
  emphasized: 900,
  button: 900,
  bold: 700,
};

export const textStyles = {
  display: {
    fontSize: typeScale.display,
    lineHeight: lineHeight.display,
  },
  heading: {
    fontSize: typeScale.heading,
    lineHeight: lineHeight.heading,
  },
  subheading: {
    fontSize: typeScale.subheading,
    lineHeight: lineHeight.subheading,
    margin: 0,
  },
  body: {
    fontSize: typeScale.body,
    lineHeight: lineHeight.body,
  },
  caption: {
    fontSize: typeScale.caption,
    lineHeight: lineHeight.caption,
  },
};
